const mediaQuery = (size) => `(min-width: ${size})`

export const devices = {
  mobile: mediaQuery('576px'),
  tabletPortrait: mediaQuery('768px'),
  desktop: mediaQuery('992px'),
  hd: mediaQuery('1200px'),
}
